import { RootState } from '../../../../../init-store';

export const selectMicrophoneDevicePermission = (state: RootState) => state.call.device.microphoneDevicePermission;
export const selectCameraDevicePermission = (state: RootState) => state.call.device.cameraDevicePermission;
